import { call, put, select, takeLatest } from 'redux-saga/effects'
import { PcrDocsService } from '../../../../services/pcrDocs.service'
import { getPcrIdSelector } from '../../../home/selectors'
import { IPcr } from '../../../pcr/store/pcr.types'
import { getServiceIdSelector } from '../../../user/selectors'
import { saveCriticalCare } from '../store/criticalCare.actions'
import { CriticalCareConstants } from '../store/criticalCare.constants'
import { ICriticalCareState } from '../store/criticalCare.types'
import { getCriticalCareSelector } from '../selectors/criticalCare.selector'
import { performWithMutexHOG } from '../../../../services/mutexUtility.service'

export function* setComments() {
  const criticalCareState: ICriticalCareState = yield select(getCriticalCareSelector)
  const { comments } = criticalCareState
  const serviceId: string = yield select(getServiceIdSelector)
  const pcrDocsService = new PcrDocsService(serviceId)
  const pcrID: string = yield select(getPcrIdSelector)
  if (pcrID) {
    const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
    if (pcrDoc.patient?.criticalCareStateList && pcrDoc.patient?.criticalCareStateList.length) {
      const index = pcrDoc.patient?.criticalCareStateList?.findIndex(
        (criticalCare) => criticalCare.key === criticalCareState.key
      )
      if (index !== -1) {
        if (pcrDoc.patient.criticalCareStateList[index].comments !== comments) {
          yield put(saveCriticalCare())
        }
      }
    } else {
      yield put(saveCriticalCare())
    }
  } else {
    // todo: add to audit log
  }
}

export function* setCommentsSaga() {
  yield takeLatest([CriticalCareConstants.SET_COMMENTS], performWithMutexHOG, setComments)
}
